import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from '../../context/language';
import {theme} from '../../styles/darkTheme';
import Button from '../../components/atoms/Buttons/CommonBtn';
import CustomPhoneInput from '../../components/atoms/CustomPhoneInput';
import Input from '../../components/atoms/Input';
import {BottomContainer, Container, IconButton} from './styles';
import BackArrow from '../../assets/icons/BackArrow.svg';
import {selectOrCreateChat} from '../../redux/actions/channel';
import {RootState} from '../../redux/reducers';
import axios from '../../utils/axios';
import {isPossiblePhoneNumber, parsePhoneNumber} from 'libphonenumber-js';
import Alert from '../../components/atoms/Alert';
import {
  EmailIcon,
  EmailShareButton,
  TelegramIcon,
  TelegramShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share';
import {setAlert} from '../../redux/actions/global';
import {getErrorMessage} from '../../utils/getters';

const AddContact = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [phoneInfo, setPhoneInfo] = useState('');
  const [contactName, setContactName] = useState('');
  const [disabledInput, setDisabledInput] = useState(false);
  const [userData, setUserData] = useState<{id: string}>({id: ''});
  const [visible, setIsvisible] = useState(false);
  const user = useSelector((state: RootState) => ({...state.user}));
  const {text} = useTranslation();
  const history = useNavigate();
  const dispatch = useDispatch();

  const createChat = ({id}: {id: string}): void => {
    if (id) {
      dispatch(
        selectOrCreateChat({
          members: [user.id, id],
          callback: () => history('/chat_room'),
        }),
      );
    }
  };

  const getUserData = async () => {
    try {
      if (phoneInfo && isPossiblePhoneNumber(phoneInfo)) {
        const phoneNumber = parsePhoneNumber(phoneInfo);
        if (!phoneNumber.country) {
          return dispatch(
            setAlert({title: text.error, message: text.invalidPhoneNumber}),
          );
        }
        const info = {
          phoneNumber: {
            dialCountryCode: `+${phoneNumber.countryCallingCode}`,
            mobileNumber: phoneNumber.nationalNumber,
          },
          fullName: contactName,
        };
        const url = '/api/v1/user/widget/init_chat/';
        setIsLoading(true);
        const res = await axios.post(url, info);
        setIsLoading(false);
        return res.data;
      }
    } catch (e: any) {
      setIsLoading(false);
      dispatch(
        setAlert({
          title: e.name,
          message: getErrorMessage(e.response.status || 500, text),
          callback: () => history('/welcome'),
        }),
      );
      return null;
    }
  };

  const handleClick = async () => {
    const data = await getUserData();
    if (data) {
      setUserData(data);
      if (!data.hasRegistered) {
        return setIsvisible(true);
      }
      createChat({id: data.id});
    }
  };

  return (
    <Container theme={theme}>
      <div onClick={() => history(-1)}>
        <IconButton src={BackArrow} size={24} />
      </div>
      <Input
        type={'text'}
        label={text.contact}
        placeholder={text.namePlaceholder}
        theme={theme}
        value={contactName}
        onChange={setContactName}
        disabled={disabledInput}
      />
      <CustomPhoneInput
        value={phoneInfo}
        setValue={setPhoneInfo}
        disabled={disabledInput}
      />
      <BottomContainer>
        <Button
          validation={phoneInfo != '' && contactName != ''}
          onClick={handleClick}>
          {text.addChat}
        </Button>
      </BottomContainer>
      <Alert
        isVisible={visible}
        setIsVisible={setIsvisible}
        title={text.invite}
        message={text.inviteMessage(contactName)}
        callback={() => createChat({id: userData.id})}>
        <>
          <WhatsappShareButton
            url={text.inviteMessageOut}
            style={{marginRight: 5}}>
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
          <TelegramShareButton
            url={text.inviteMessageOut}
            style={{marginRight: 5}}>
            <TelegramIcon size={32} round />
          </TelegramShareButton>
          <EmailShareButton
            url={text.inviteMessageOut}
            style={{marginRight: 5}}>
            <EmailIcon size={32} round />
          </EmailShareButton>
        </>
      </Alert>
    </Container>
  );
};

export default AddContact;
